<template>
  <div class="contacts">
    <div class="contacts__in">
      <div class="contacts__l">
        <div class="contacts__map">
          <GmapMap
            :center="map_center"
            :options="mapOptions"
            style="width: 100%; height: 345px">
            <GmapMarker :clickable="false" :icon="mapIcon" :position="mapOptions.center2">
              <GmapInfoWindow :opened="true" :options="infoOptions">
                <div>

                  <b>Forestal Group S.L.U </b>Carretera General 2, Km 4, d’Encamp<br>
                  Local 5, Nau 2. Naus Illes Bartra<br>
                  AD200. Andorra<br>
                  <a href="tel:+376737704">+376 737 704</a>
                </div>

              </GmapInfoWindow>
            </GmapMarker>
            <GmapMarker
              :clickable="true"
              :icon="mapIcon"
              :position="map2Center"
              @click="toggleLogistic"
            >
              <GmapInfoWindow :opened="logisticOpen" :options="infoOptionsSecond">
                <div>
                  <b>Logistic Center Address</b><br>
                  Pol. Ind. Montferrer,<br>
                  Subinyes, 9 25711 Montferrer (Lleida),<br>
                  Barcelona, Spain
                </div>
              </GmapInfoWindow>
            </GmapMarker>
          </GmapMap>
        </div>
      </div>

      <div class="contacts__r">
        <div class="contacts__form">
          <div class="contacts__form-in">
            <div class="contacts__text">
              {{ trans.text.contacts.contact }}
            </div>

            <form @submit="submit">
              <div class="inp-group">
                <label for="myinfo-fn">{{ trans.text.contacts.firstName }}</label>
                <input id="myinfo-fn" v-model.trim="name" class="inp-style inp-fw" type="text">
              </div>

              <div class="inp-group">
                <label for="myinfo-email">E-mail</label>
                <input id="myinfo-email" v-model.email="email" class="inp-style inp-fw" type="email">
              </div>

              <div class="inp-group inp-group__textarea">
                <label for="myinfo-subject">{{ trans.text.contacts.subject }}</label>
                <input id="myinfo-subject" v-model.trim="subject" class="inp-style inp-fw" type="text">
              </div>

              <div class="inp-group inp-group__textarea">
                <label for="myinfo-message">
                  {{ trans.text.contacts.message }}
                </label>
                <textarea
                  id="myinfo-message"
                  v-model.trim="message"
                  class="inp-style inp-fw"
                  type="text">
                </textarea>
              </div>

              <div class="contacts__form-checkbox">
                <input
                  id="styled-checkbox"
                  v-model="accept"
                  class="inp-group__checkbox"
                  type="checkbox"
                >
                <label for="styled-checkbox">
                  <span class="checkbox"></span>
                  <span>{{ trans.text.contacts.iHaveRead }} <a
                    :href="`/${lang}/page/data-protection-basic-information-contacs`"
                    target="_blank">{{ trans.text.contacts.data }}</a> {{ trans.text.contacts.clause }}</span>
                </label>
              </div>

              <div v-if="errors.length" class="error">
                <p v-for="error in errors">{{ error }}</p>
              </div>

              <div class="contacts__form-btn">
                <button
                  :class="{'btn-green': isFillFields || !showCheckbox, 'btn-gray': !isFillFields && showCheckbox}"
                  class="btn btn-block"
                >
                  <template v-if="showCheckbox">
                    {{ trans.text.contacts.send }}
                  </template>
                  <template v-if="!showCheckbox">
                    {{ trans.text.contacts.successMessage }}
                  </template>
                </button>
              </div>

            </form>

            <div class="contacts__form-footer">
              <!--              <nav v-if="false" class="contacts__links">-->
              <!--                <ul>-->
              <!--                  <li>-->
              <!--                    <a-->
              <!--                      class="btn btn-gray btn&#45;&#45;mini"-->
              <!--                      href="/static/pages/SvPD5SM249i3hDxPMoEP21KMwv97Yljhbnd2TKVj.pdf"-->
              <!--                      target="_blank"-->
              <!--                    >-->
              <!--                      {{ trans.text.contacts.pressRelease }}-->
              <!--                    </a>-->
              <!--                  </li>-->
              <!--                </ul>-->
              <!--              </nav>-->

              <nav class="contacts__social">
                <ul>
                  <li>
                    <a href="https://www.facebook.com/forestalbikes/" target="_blank">
                      <svg class="icon icon-facebook">
                        <use xlink:href="#icon-facebook" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                      </svg>
                    </a>
                  </li>

                  <li>
                    <a href="https://www.instagram.com/forestalbikes/" target="_blank">
                      <svg class="icon icon-instagram">
                        <use xlink:href="#icon-instagram" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                      </svg>
                    </a>
                  </li>

                  <li>
                    <a href="https://www.youtube.com/channel/UCdum5pdNzVMg7g7fiUOdv7A"
                       target="_blank">
                      <svg class="icon icon-youtube">
                        <use xlink:href="#icon-youtube" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                      </svg>
                    </a>
                  </li>

                  <li>
                    <a href="https://www.linkedin.com/company/forestal/" target="_blank">
                      <svg class="icon icon-linkedin" viewBox="0 0 20 20">
                        <path
                          clip-rule="evenodd"
                          d="M5.5 1H14.504C16.987 1 19 3.013 19 5.495V14.504C19 16.987 16.987 19 14.504 19H5.496C3.013 19 1 16.987 1 14.504V5.5C1 3.015 3.015 1 5.5 1Z"
                          fill-rule="evenodd"
                          stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="1.5"
                        />
                        <path
                          d="M6.11914 9.09961V14.4996"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.5"
                        />
                        <path
                          d="M9.71875 14.4996V11.3496C9.71875 10.1066 10.7268 9.09961 11.9688 9.09961C13.2118 9.09961 14.2188 10.1066 14.2188 11.3496V14.4996"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.5"
                        />
                        <path
                          d="M6.11758 5.83691C5.99358 5.83791 5.89258 5.93891 5.89258 6.06291C5.89358 6.18691 5.99458 6.28691 6.11858 6.28691C6.24258 6.28691 6.34358 6.18691 6.34358 6.06291C6.34358 5.93891 6.24258 5.83691 6.11858 5.83691"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.5"
                        />
                      </svg>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {gmapApi} from 'vue2-google-maps'
import GmapCustomMarker from 'vue2-gmap-custom-marker';

export default {
  name: "Contacts",
  props: ['lang', 'trans'],
  components: {
    'gmap-custom-marker': GmapCustomMarker
  },
  data() {
    return {
      logisticOpen: false,
      infoOptions: {
        pixelOffset: {
          width: 95,
          height: 0
        }
      },
      infoOptionsSecond: {
        pixelOffset: {
          width: 90,
          height: 0
        }
      },
      map2Center: {
        lat: 42.340154513231106,
        lng: 1.4198845632966992
      },
      mapOptions: {
        center2: {
          lat: 42.502580,
          lng: 1.512780
        },
        zoom: 8,
        mapTypeControl: false,
        styles: [
          {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#e9e9e9"
              },
              {
                "lightness": 17
              }
            ]
          },
          {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#f5f5f5"
              },
              {
                "lightness": 20
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#ffffff"
              },
              {
                "lightness": 17
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "color": "#ffffff"
              },
              {
                "lightness": 29
              },
              {
                "weight": 0.2
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#ffffff"
              },
              {
                "lightness": 18
              }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#ffffff"
              },
              {
                "lightness": 16
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#f5f5f5"
              },
              {
                "lightness": 21
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#dedede"
              },
              {
                "lightness": 21
              }
            ]
          },
          {
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "visibility": "on"
              },
              {
                "color": "#ffffff"
              },
              {
                "lightness": 16
              }
            ]
          },
          {
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "saturation": 36
              },
              {
                "color": "#333333"
              },
              {
                "lightness": 40
              }
            ]
          },
          {
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#f2f2f2"
              },
              {
                "lightness": 19
              }
            ]
          },
          {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#fefefe"
              },
              {
                "lightness": 20
              }
            ]
          },
          {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "color": "#fefefe"
              },
              {
                "lightness": 17
              },
              {
                "weight": 1.2
              }
            ]
          }
        ]
      },
      errors: [],
      name: null,
      email: null,
      subject: null,
      message: null,
      accept: false,
      showCheckbox: true,
      successMessage: this.trans.text.contacts.successMessage
    }
  },
  computed: {
    map_center() {
      return {lat: 42.300080, lng: 2.324780}
    },
    google: gmapApi,
    mapIcon() {
      if (this.google) {
        return {
          url: '/assets/images/marker.svg',
          scaledSize: new this.google.maps.Size(12, 14),
        };
      } else {
        return {
          url: '/assets/images/marker.svg'
        }
      }
    },
    isFillFields() {
      return this.isValidForm()
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const subject = urlParams.get('subject');
    if (subject) {
      this.subject = subject
      window.history.replaceState({}, document.title, window.location.origin + window.location.pathname);
    }
  },
  methods: {
    toggleLogistic() {
      this.logisticOpen = !this.logisticOpen
    },
    submit(e) {
      e.preventDefault();

      this.errors = [];
      if (this.validateForm() === false) {
        return false;
      }

      let ctx = this;

      axios
        .post(this.$path + '/feedback',
          {
            name: this.name,
            email: this.email,
            subject: this.subject,
            message: this.message,
          },
          {headers: {Authorization: 'Bearer ' + localStorage.getItem('access_token')}})
        .then(response => {
          this.clearForm();
          ctx.showCheckbox = false;
          setTimeout(function () {
            ctx.showCheckbox = true;
          }, 5000)
        })
        .catch(err => {
          if (err.response.data.hasOwnProperty('errors')) {
            for (let error of err.response.data.errors) {
              this.errors.push(error[0]);
            }
          } else {
            this.errors.push(err.response.data.message);
          }
        })
    },
    validateForm() {
      let hasErrors = false
      if (!this.name) {
        this.errors.push(this.trans.text.contacts.requiredName);
        return false
      }
      if (!this.email) {
        this.errors.push(this.trans.text.contacts.requiredEmail);
        return false
      }
      if (!this.validEmail()) {
        this.errors.push(this.trans.text.contacts.invalidEmail);
        return false
      }
      if (!this.subject) {
        this.errors.push(this.trans.text.contacts.requiredSubject);
        return false
      }
      if (!this.message) {
        this.errors.push(this.trans.text.contacts.requiredMessage);
        return false
      }
      if (!this.accept) {
        this.errors.push(this.trans.text.contacts.requiredAccept);
        return false
      }

      return this.isValidForm();
    },
    isValidForm() {
      return !!this.name
        && !!this.email
        && !!this.subject
        && !!this.message
        && !!this.accept
        && !!this.validEmail();
    },
    validEmail() {
      let regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regExp.test(this.email);
    },
    clearForm() {
      this.name = null;
      this.email = null;
      this.subject = null;
      this.message = null;
      this.accept = false;
    },
  }

}
</script>

<style scoped>
.contacts__form-checkbox strong {
  line-height: 25px;
}

@media (max-width: 514px) {
  .contacts__form-checkbox strong {
    line-height: 42px;
  }
}

.contacts__form-btn .btn.btn-gray {
  cursor: auto;
}

.contacts__form-btn .btn.btn-gray:hover {
  background-color: #efefef;
  color: rgba(0, 0, 0, .5);
}

.error {
  margin-top: 20px;
  font-size: 14px;
  color: #E41B1B;
  display: block;
}

.marker-label {
  cursor: auto;
  min-width: 155px;
  max-width: 155px;
  position: absolute;
  overflow: hidden;
  margin-left: 10px;
  margin-top: -153px;
  left: 0;
  top: -8px;
  z-index: 1;
  display: block;
}

.marker-label a {
  color: #000;
}

.marker-label.second {
  top: 35px;
}
</style>
